module.exports = __webpack_public_path__ + "static/media/empity_gas.0db6ee86.svg";